import { useState } from "react";

import { FrmSelectFromObjects } from "components/formFields/FrmSelectFromObjects";

import { getTimeZoneOptions } from "services/utility/dates";

export function FrmTimeZone(props) {
  const { name, value, onValueChange } = props;
  const [options, setOptions] = useState(getTimeZoneOptions());

  return (
    <FrmSelectFromObjects
      name={name}
      value={value}
      onOpen={() => setOptions(getTimeZoneOptions())}
      options={options}
      onValueChange={onValueChange}
      disableClearable
    />
  );
}
